import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DynamicFooterComponent } from './dynamic-footer.component';

const routes: Routes = [{ path: '', component: DynamicFooterComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DynamicFooterRoutingModule { }
